/**
 * Minified by jsDelivr using UglifyJS v3.4.4.
 * Original file: /gh/moment/moment@2.24.0/moment.js
 * 
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
